import React from "react";
import { useDispatch } from "react-redux";
import { useGlobalContext } from "context/global";
import Modal from "components/modal";
import { TOGGLE_SAVE_POPUP, DISCARD_CHANGES } from "utils/action-types";
import navigate from "helpers/navigate";

const SaveChangesPopup = ({ isOpen, redirectPath }) => {
	const { translation } = useGlobalContext();
	const dispatch = useDispatch();

	const cancel = () => {
		dispatch({ type: TOGGLE_SAVE_POPUP, payload: { show: false } });
	};

	const discardChanges = () => {
		dispatch({ type: DISCARD_CHANGES });
		dispatch({ type: TOGGLE_SAVE_POPUP, payload: { show: false } });
		if (redirectPath) navigate(redirectPath);
	};

	return (
		<Modal
			isOpen={isOpen}
			className="max-w-[450px]"
			overlayClassName="max-w-none"
			hideHeader={true}
		>
			<div className="p-10 flex flex-col gap-3 items-center text-center">
				<h3 className="mb-4">{translation.subscription?.leave_changes}</h3>
				<button className="btn-primary w-full " onClick={discardChanges}>
					{translation.other?.leave ?? "Leave"}
				</button>
				<button className="btn-tertiary" onClick={cancel}>
					{translation.other?.cancel ?? "Cancel"}
				</button>
			</div>
		</Modal>
	);
};

export default SaveChangesPopup;